import { api } from "@api/api";
import { Voucher } from "@modules/vouchers/types";
import { VoucherFormValues } from "@modules/vouchers/validations";

export async function editVoucherService(id: string, data: Partial<VoucherFormValues>): Promise<Voucher> {
  const { data: voucher } = await api.patch<Voucher>(`v1/voucher_batch_admin/${id}/`, data);

  return voucher;
}
